import React from 'react';
import { convertFirstCharToUppercase } from '../../../Tools/convertFirstLetterToUppercase';

class DataTable {

    CancellationSummary = ( self ) => {
      const CancellationSummaryColumns = [
        {
          title: 'Reason for Cancellation',
          dataIndex: 'cancelation_reason',
          key: 'cancelation_reason',
          sorter: false,
          showSorterTooltip: false,
          className: 'tname',
          render: (text, record) =>
          {
              switch(record?.cancelation_reason)
              {
                case "death_of_dog":
                  return <span className="type ellipse">Loss of Pet</span>
                case "service":
                  return <span className="type ellipse">Service Quality</span>
                case "moving":
                  return <span className="type ellipse">Moving</span>
                case "competition":
                  return <span className="type ellipse">Pricing</span>
                case "other":
                  return <span className="type ellipse">Other</span>
              }
          }
        },
        {
          title: 'Qty',
          dataIndex: 'quantity',
          key: 'quantity',
          sorter: false,
          showSorterTooltip: false,
          className: 'tname',
          render: (text, record) => (<span className="type ellipse">{record?.quantity}</span>)
        },
        {
          title: '%',
          dataIndex: 'percentage',
          key: 'percentage',
          sorter: false,
          showSorterTooltip: false,
          className: 'tname',
          render: (text, record) => (<span className="type ellipse">{parseFloat(record?.percentage).toFixed()}%</span>)
        }
      ]
      return CancellationSummaryColumns;
    }
}
export default new DataTable();